<template>
  <div class="card shadow-4 h-100">
    <div class="card-body">
      <h3 class="text-info mb-5 text-uppercase pl-5">Utilisateurs</h3>
      <p class="card-description">Modifiez le nombre d'utilisateurs</p>
      <div class="my-6 d-flex align-items-center">
        <div class="text-right" style="flex: 1 0 auto">
          <button class="text-info pointer"
                  style="border: solid 2px #936fde; border-radius: 100%; width: 40px; height: 40px" @click="incrementUsers(-1)">
            <span class="font-weight-bold">-</span>
          </button>
        </div>
        <div class="text-center">
          <h5 class="my-0 mx-4">{{ usersToAdd }} collaborateur{{ usersToAdd > 1 ? 's' : '' }}</h5>
        </div>
        <div class="text-left" style="flex: 1 0 auto">
          <button class="text-info pointer"
                  style="border: solid 2px #936fde; border-radius: 100%; width: 40px; height: 40px" @click="incrementUsers()">
            <span class="font-weight-bold">+</span>
          </button>
        </div>
      </div>
      <div class="text-center">
        <button :disabled="loading || usersToAdd == premiumMaxUsers" class="btn btn-round btn-info w-50" @click="modifyMaxUsers()">
          Valider
        </button>
      </div>

      <!-- MODAL UNAUTHORIZED MODIFICATION USERS -->
      <div id="unauthorizedModificationUsers" class="modal fade" data-backdrop="static" role="dialog">
        <div class="modal-dialog" role="document">
          <div class="modal-content">
            <div class="modal-header">
              <h5 class="modal-title">Vous n'avez pas les droits nécessaires</h5>
              <button class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              Seul un <b>administrateur du compte</b> peut modifier le nombre d'utilisateurs.<br>
              Merci de vous rapprocher d'un administrateur ou de nous contacter à <a href="mailto:premium@bubbleplan.net">premium@bubbleplan.net</a> en cas d'indisponibilité.
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-primary" data-dismiss="modal">Fermer</button>
            </div>
          </div>
        </div>
      </div>
      <!-- END MODAL UNAUTHORIZED MODIFICATION USERS -->

      <div class="mt-2 text-center px-xl-8" style="line-height: 1.3">
        <small class="text-muted">Le changement sera répercuté sur la prochaine facture au prorata de la période en cours.</small>
      </div>
    </div>
  </div>
</template>

<script>
  import apiSrv from '../apiSrv';

  export default {
    props: {
      user: { type: Object, required: true },
    },
    data() {
      return {
        loading: false,
        usersToAdd: this.user.company.maxusers,
      };
    },
    computed: {
      premiumMaxUsers() { return this.user.company && this.user.company.maxusers; },
      isAdmin() { return this.user && this.user.access_right == 'company_admin'; },
    },
    methods: {
      incrementUsers(increment = 1) {
        if (! this.isAdmin) {
          $('#unauthorizedModificationUsers').modal('show');
          return;
        }
        this.usersToAdd += increment;
        if (this.usersToAdd < 1) this.usersToAdd = 1;
        if (this.usersToAdd > 50) this.usersToAdd = 50;
      },
      modifyMaxUsers() {
        if (this.usersToAdd == this.premiumMaxUsers) return;
        this.loading = true;
        if (this.isAdmin) {
          apiSrv.call(`${window.api.buy.url}/plan/quantity/${this.usersToAdd}`, 'PUT').then(() => {
            window.location.reload();
          }).catch((message) => {
            this.loading = false;
            console.error(message);
          });
        } else {
          $('#unauthorizedModificationUsers').modal('show');
        }
      },
    },
  };
</script>
